const subscribersMap = new Map()
const delaySubscribersMap = new Map()
import { useGamesStore } from 'src/stores/games'

let timeout = null

function updateMapCallbacks(map, tableId, callback) {
  if (!map.has(tableId)) {
    map.set(tableId, [callback])
    return
  }

  const existingCallbacks = map.get(tableId)
  if (Array.isArray(callback)) {
    map.set(tableId, [...callback, ...existingCallbacks])
    return
  }
  map.set(tableId, [callback, ...existingCallbacks])
}

function executeAllCallbacks(map, tableId, data) {
  if (!map.has(tableId)) {
    return
  }

  const callbacks = map.get(tableId)
  callbacks.forEach((callback) => {
    if (typeof callback === 'function') {
      callback(data)
    }
  })
}

export const dga = {
  websocket: null,
  wsUri: null,
  tableId: null,
  casinoId: null,
  tryToConnect: true,
  availableTables: null,
  currency: null,

  // public
  connect: function (wsUri, casinoId, currency) {
    const self = this
    self.tryToConnect = true
    self.wsUri = wsUri
    self.currency = currency
    if (self.websocket !== null && ![2, 3].includes(self.websocket.readyState)) {
      self.tryToConnect === false
      self.websocket.close()
    }
    self.websocket = new WebSocket('wss://' + wsUri + '/ws')
    self.websocket.onopen = function (evt) {
      self.onWsOpen(evt, casinoId)
    }
    self.websocket.onclose = function (evt) {
      self.onWsClose(evt)
    }
    self.websocket.onmessage = function (evt) {
      self.onWsMessage(evt)
    }
    self.websocket.onerror = function (_evt) {
      // self.onWsError(evt)
    }
    self.casinoId = casinoId
  },
  // public
  onMessage: function (data) {
    const id = data.tableId

    if (data.tableKey) {
      this.availableTables = data.tableKey
      useGamesStore().updateDgaTableIds(data.tableKey)

      for (let tableId of delaySubscribersMap.keys()) {
        if (this.availableTables) {
          if (this.availableTables.includes(tableId)) {
            this.subscribe(tableId, delaySubscribersMap.get(tableId))
            delaySubscribersMap.delete(tableId)
          }
        }
      }
    }

    executeAllCallbacks(subscribersMap, id, data)
  },
  // public
  onConnect: function () {
    this.available(this.casinoId)
  },
  // public
  disconnect: function () {
    const self = this
    self.tryToConnect = false
    self.websocket.close()
    this.availableTables = null
  },
  // public
  subscribe: function (tableId, callback) {
    const subscribeMessage = {
      type: 'subscribe',
      key: tableId,
      casinoId: this.casinoId,
      currency: this.currency,
    }
    const self = this

    if (self.websocket === null || self.websocket.readyState !== WebSocket.OPEN) {
      updateMapCallbacks(delaySubscribersMap, tableId, callback)
      return
    }

    updateMapCallbacks(subscribersMap, tableId, callback)
    self.doWsSend(JSON.stringify(subscribeMessage))
  },

  unsubscribe: function (tableId) {
    subscribersMap.delete(tableId)
  },

  // public
  available: function (casinoId) {
    const availableMessage = {
      type: 'available',
      casinoId: casinoId,
    }

    const self = this
    const jsonSub = JSON.stringify(availableMessage)
    self.doWsSend(jsonSub)
  },

  onWsOpen: function () {
    const self = this

    if (self.onConnect != null) {
      self.onConnect()
    }
  },

  onWsClose: function () {
    const self = this
    if (self.tryToConnect === true) {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        self.connect(self.wsUri, self.casinoId)
      }, 5000)
    }
  },

  onWsMessage: function (evt) {
    const self = this
    const data = JSON.parse(evt.data)
    if (self.onMessage != null) {
      self.onMessage(data)
    }
  },

  // onWsError: function (evt) {
  //   console.error('ERROR: ')
  // },

  ping: function () {
    const self = this
    const pingMessage = {
      type: 'ping',
      pingTime: Date.now().toString(),
    }
    const jsonSub = JSON.stringify(pingMessage)
    self.doWsSend(jsonSub)
  },

  doWsSend: function (message) {
    const self = this
    self.websocket.send(message)
  },
}
